import MojitoServices from 'mojito/services';

import {mergeToHierarchy} from '#core/utils/config-utils.js';

import {
    EmptyContentHeadMetaFactory,
    EventHeadMetaFactory,
    HomePageHeadMetaFactory,
    InplayHeadMetaFactory,
    SportHeadMetaFactory,
    RaceMeetingHeadMetaFactory,
    SportCouponHeadMetaFactory,
    VirtualsHeadMetaFactory,
} from '#core/application/seo/head-meta-factory.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {sportsContentFactory} from './sports-content.factory';

import PALETTE_SCHEMA from './sports-content.palette-schema.yaml';
import SCHEMA from './sports-content.schema.yaml';

const {GROUP_TYPES: MARKET_GROUP_TYPES} = MojitoServices.SportsContent.MarketGroups.types;

class SportsContentFeature extends AbstractVisualFeature {
    get name() {
        return 'Sports Content';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return sportsContentFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const eventMarketsSwitcherGroupCategoriesMap = this.config.eventMarketsSwitcherGroupCategories.reduce(
            (acc, categoryId) => ({
                ...acc,
                [categoryId]: true,
            }),
            {}
        );

        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            EventPage: {
                documentHeadMetaFactory: EventHeadMetaFactory,
            },
            EventMarkets: {
                initiallyExpandedMarkets: this.config.eventPageInitiallyExpandedMarketsAmount,
            },
            SingleLeaguePage: {
                documentHeadMetaFactory: SportHeadMetaFactory,
            },
            SportCouponPageView: {
                documentHeadMetaFactory: SportCouponHeadMetaFactory,
            },
            InPlayPage: {
                documentHeadMetaFactory: InplayHeadMetaFactory,
            },
            RaceMeetingPageView: {
                documentHeadMetaFactory: RaceMeetingHeadMetaFactory,
            },
            SportPage: {
                documentHeadMetaFactory: SportHeadMetaFactory,
            },
            VirtualSportPageView: {
                documentHeadMetaFactory: VirtualsHeadMetaFactory,
            },
            HomePage: {
                documentHeadMetaFactory: HomePageHeadMetaFactory,
                topSportCoupons: {
                    primary: {
                        coupon: {
                            view: {
                                eventCounter: {
                                    footerSelectedSport: true,
                                },
                            },
                        },
                    },
                },
            },
            EmptyContent: {
                documentHeadMetaFactory: EmptyContentHeadMetaFactory,
            },
            EventMarketsGroupSwitcher: {
                marketGroupCategories: [
                    {
                        id: 'markets',
                        label: '$EVENT_MARKETS_GROUP_SWITCHER.CATEGORIES.MARKETS',
                        combineOther: true,
                        default: false,
                        hideOneMarketGroup: false,
                    },
                    {
                        id: 'match_acca',
                        label: '$EVENT_MARKETS_GROUP_SWITCHER.CATEGORIES.MATCH_ACCA',
                        marketGroupFilter: marketGroup => marketGroup.type === MARKET_GROUP_TYPES.MATCH_ACCA,
                        default: false,
                        hideOneMarketGroup: true,
                    },
                    {
                        id: 'prebuilt_match_acca',
                        label: '$EVENT_MARKETS_GROUP_SWITCHER.CATEGORIES.PREBUILT_MATCH_ACCA',
                        marketGroupFilter: marketGroup => marketGroup.type === MARKET_GROUP_TYPES.PREBUILT_MATCH_ACCA,
                        default: false,
                        hideOneMarketGroup: true,
                    },
                    {
                        id: 'fast_markets',
                        label: '$EVENT_MARKETS_GROUP_SWITCHER.CATEGORIES.FAST_MARKETS',
                        marketGroupFilter: marketGroup => marketGroup.type === MARKET_GROUP_TYPES.FAST_MARKETS,
                        default: false,
                        hideOneMarketGroup: true,
                    },
                ].filter(category => eventMarketsSwitcherGroupCategoriesMap[category.id]),
            },
        });
        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

export const SportsContent = new SportsContentFeature(allVisuals);
